import { 
    SAVINGS_POT_CALCULATOR_SHOW_RESULT_SUMMARY
} from "../../../actions/savingsPotCalculator/savingsPotCalculatorForm"
import { fireGtmEvent } from "../gtmEvents";

import {findOtherEventIndex, otherEventTracking} from '../otherEventTracking';;

export const savingsPotCalculatorFieldTracking = (store, next, action) => {
    const result = next(action);
    let otherEventIndex;

    const field = (() => {
        switch (action.type){
            case SAVINGS_POT_CALCULATOR_SHOW_RESULT_SUMMARY: 
            otherEventIndex = findOtherEventIndex('BUTTON_CLICKED');
            fireGtmEvent('calculator_complete', { calculator_type: 'Savings Pot Calculator' });
            return 'Savings Pot Calculator';
        }
    })();

    if (field) {
        otherEventTracking(action.type, otherEventIndex, field);
    }

    return result;
};